import React, { useEffect } from "react";
import Lenis from "lenis";

/**
 * Momentum smooth-scroll wrapper (Awwwards-grade feel).
 * Excludes admin routes — they need native scroll for editors.
 */
export function SmoothScroll({ enabled = true, children }) {
  useEffect(() => {
    if (!enabled) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 0.95,
      touchMultiplier: 1.2,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [enabled]);
  return <div style={{ position: "relative" }}>{children}</div>;
}
